<template>
    <div>
        <div class="grid-container">
            <div class="grid-x grid-padding-x pad-top">
                <div class="cell small-12">
                    <div class="search-bar">
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectGenderFilter"
                                    v-on:change="selectFilter('gender')"
                                    class="product-filter">
                                    <option value='all'>Gender</option>
                                    <option value='men'>Mens</option>
                                    <option value='women'>Womens</option>
                                    <option value='unisex'>Unisex</option>
                                    <option value='kids'>Kids &amp; Babies</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectTypeFilter"
                                    v-on:change="selectFilter('type')"
                                    class="product-filter">
                                    <option value="all">Products</option>
                                    <option value="tshirts">T-Shirts</option>
                                    <option value="lstshirts">Long Sleeved T-Shirts</option>
                                    <option value="poloshirts">Polo Shirts</option>
                                    <option value="lspoloshirts">Long Sleeved Polo Shirts</option>
                                    <option value="sweatshirts">Sweat Shirts</option>
                                    <option value="hoodies">Hoodies</option>
                                    <option value="zippedhoodies">Zipped Hoodies</option>
                                    <option value="shirts">Short Sleeved Shirts</option>
                                    <option value="lsshirts">Long Sleeved Shirts</option>
                                    <option value="jackets">Jackets</option>
                                    <option value="bodywarmers">Bodywarmers &amp; Gilets</option>
                                    <option value="softshelljackets">Soft Shell Jackets</option>
                                    <option value="fleeces">Fleeces</option>
                                    <option value="hvjackets">Hi-Vis Jackets</option>
                                    <option value="hvtspolos">Hi-Vis T-Shirts / Polos</option>
                                    <option value="hvvests">Hi-Vis Vests</option>
                                    <option value="hvtrousers">Hi-Vis Trousers</option>
                                    <option value="beanies">Beanies</option>
                                    <option value="caps">Caps</option>
                                    <option value="totebags">Tote Bags</option>
                                    <option value="drawstringgymbags">Gym Bags</option>
                                    <option value="backpacks">Backpacks</option>
                                    <option value="messengerbags">Messenger Bags</option>
                                    <option value="travelbags">Travel Bags</option>
                                    <option value="joggingbottoms">Tracksuit Bottoms</option>
                                    <option value="trousers">Trousers</option>
                                    <option value="shorts">Shorts</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectBrandFilter"
                                    v-on:change="selectFilter('brand')"
                                    class="product-filter">
                                    <option value="all">Brand</option>
                                    <option value="American Apparel">American Apparel</option>
                                    <option value="Anvil">Anvil</option>
                                    <option value="AWDis">AWDis</option>
                                    <option value="BagBase">BagBase</option>
                                    <option value="Beechfield">Beechfield</option>
                                    <option value="Bella-Canvas">Bella-Canvas</option>
                                    <option value="Brook Taverner">Brook Taverner</option>
                                    <option value="Canterbury">Canterbury</option>
                                    <option value="Craghoppers">Craghoppers</option>
                                    <option value="Dickies">Dickies</option>
                                    <option value="Ecologie">Ecologie</option>
                                    <option value="Errea">Errea</option>
                                    <option value="Finden and Hales">Finden and Hales</option>
                                    <option value="Flexfit">Flexfit</option>
                                    <option value="Front Row">Front Row</option>
                                    <option value="Fruit of the Loom">Fruit of the Loom</option>
                                    <option value="Gamegear">Gamegear</option>
                                    <option value="Gildan">Gildan</option>
                                    <option value="Glenmuir">Glenmuir</option>
                                    <option value="Henbury">Henbury</option>
                                    <option value="Jerzees">Jerzees</option>
                                    <option value="Kariban">Kariban</option>
                                    <option value="Kustom Kit">Kustom Kit</option>
                                    <option value="Larkwood">Larkwood</option>
                                    <option value="Original FNB">Original FNB</option>
                                    <option value="Portwest">Portwest</option>
                                    <option value="Premier">Premier</option>
                                    <option value="PRO RTX">PRO RTX</option>
                                    <option value="Proact">Proact</option>
                                    <option value="Quadra">Quadra</option>
                                    <option value="Regatta">Regatta</option>
                                    <option value="Result">Result</option>
                                    <option value="Russell">Russell</option>
                                    <option value="Skinny Fit">Skinny Fit</option>
                                    <option value="So Denim">So Denim</option>
                                    <option value="SOL">SOL</option>
                                    <option value="Spiro">Spiro</option>
                                    <option value="Splashmacs">Splashmacs</option>
                                    <option value="Superstar">Superstar</option>
                                    <option value="Tactical Threads">Tactical Threads</option>
                                    <option value="Tee Jays">Tee Jays</option>
                                    <option value="Tombo">Tombo</option>
                                    <option value="Warrior">Warrior</option>
                                    <option value="Westford Mills">Westford Mills</option>
                                    <option value="Yoko">Yoko</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-2">
                                <select
                                    v-model="selectOrderPrice"
                                    v-on:change="selectFilter('orderPrice')"
                                    class="product-filter">
                                    <option value="all">Sort by Price</option>
                                    <option value="orderPriceHiLo">Price Hi to Lo</option>
                                    <option value="orderPriceLoHi">Price Lo to Hi</option>
                                </select>
                            </div>
                            <div class="cell small-12 medium-4">
                                <form v-on:submit="submitSearch">
                                    <input
                                        class="product-search"
                                        placeholder="Search and hit enter"
                                        v-model="searchTerm"
                                        type="text" />
                                </form>
                            </div>
                        </div>
                    </div>
                    <div
                        v-if="message.length > 0"
                        class="clear grid-x grid-padding-x">
                        <div class="cell small-12">
                            <h2>{{ message }}</h2>
                        </div>
                    </div>
                    <div class="clear grid-x grid-margin-x">
                        <div
                            v-for="(garment, index) in garments"
                            v-bind:key="index"
                            class="cell small-6 medium-4 garment-card marg-bottom--small pad--xs relative">
                            <div>
                                <span
                                    v-if="isAuthenticated === true"
                                    v-on:click="addFavourite(garment.id)"
                                    class="favourite">
                                    <img src="../../../static/images/filter-garments/favourite.png" alt="" />
                                </span>
                                <router-link
                                    v-bind:to="`/${garment.category}/${garment.product_code}/${garment.name}`">
                                    <div class="pad--large">
                                        <img
                                            v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=300`"
                                            alt="" />
                                    </div>
                                    <p class="small">
                                        {{ garment.product_code }}<br />
                                        {{ garment.name }}<br />
                                        Price from:
                                        <span class="text-light-blue">
                                            £{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                                        </span>
                                    </p>
                                    <p class="add-to-basket">
                                        <img
                                            width="55"
                                            src="../../../static/images/filter-garments/add-to-basket.png"
                                            alt="" />
                                    </p>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                </div>
                <div class="cell small-12">
                    <div
                        v-if="message.length > 0"
                        class="clear grid-x grid-padding-x">
                        <div class="cell small-12">
                            <h2>{{ message }}</h2>
                        </div>
                    </div>
                    <div class="clear grid-x grid-margin-x">
                        <div
                            v-for="garment in garments"
                            v-bind:key="garment.id"
                            class="cell small-6 medium-3 garment-card marg-bottom--small pad--xs">
                            <div
                                v-on:click="garmentDetails(garment.id)">
                                <span class="favourite">
                                    <img src="../../../static/images/filter-garments/favourite.png" alt="" />
                                </span>
                                <div class="small-pad--small medium-pad--large">
                                    <img
                                        v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=300`"
                                        alt="" />
                                </div>
                                <p class="small">
                                    {{ garment.product_code }}<br />
                                    {{ garment.name }}<br />
                                    From:
                                    <span class="text-light-blue">
                                        £{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                v-if="singleGarment === true"
                class="modal__wrap">
                <div class="modal__inner">
                    <span 
                        v-on:click="singleGarment = false"
                        class="modal__close">X</span>
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 medium-8 bordered light shadowed">
                            <div class="pad text-center">
                                <img
                                    v-bind:src="`https://our-catalogue.com/RUNS/images/${garment.product_code}.jpg?width=400`"
                                    alt="" />
                            </div>
                        </div>
                        <div class="cell small-12 medium-4 bordered light shadowed">
                            <div class="pad">
                                <h5 class="text-blue">{{ garment.name }}</h5>
                                <p class="lead text-right text-heavy">
                                    >500 <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*21)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span><br />
                                    250-499 <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*45)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span><br />
                                    100-249 <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*55)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span><br />
                                    35-99 <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*75)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span><br />
                                    10-34 <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*90)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span><br />
                                    1-9 <span class="text-light-blue">&pound;{{ (((garment.garment_colours[0].garment_colour_sizes[0].price*115)/100)+garment.garment_colours[0].garment_colour_sizes[0].price) | numeral('0,0.00') }}</span>
                                </p>
                                <p class="text-right small">
                                    Prices exclude decoration, delivery and VAT
                                </p>
                                <label
                                    v-if="activeColour === false"
                                    class="large-label text-blue border-under">
                                    Colours
                                </label>
                                <ul v-if="activeColour === false" class="colour-list large float-right">
                                    <li
                                        class="colour-link"
                                        v-on:click="chooseColour(index)"
                                        v-for="(colour, index) in garment.garment_colours"
                                        v-bind:key="index"
                                        v-bind:style="{ backgroundColor: '#' + colour.hex_colour }"
                                        v-bind:title="colour.name">
                                        {{ colour.name }}
                                    </li>
                                </ul>
                                <p class="clear">&nbsp;</p>
                                <div v-if="activeColour !== false">
                                    <div v-if="nextButtons === false">
                                        <p class="text-right">
                                            <span
                                                class="active-colour-box"
                                                v-bind:style="{ backgroundColor: '#' + activeColour.hex_colour }">
                                                &nbsp;
                                            </span>
                                        </p>
                                        <label class="large-label text-blue border-under">Sizes</label>
                                        <form v-on:submit="addToBasket">
                                            <div class="grid-x grid-padding-x pad-top">    
                                                <div
                                                    class="cell small-12 medium-4"
                                                    v-for="(size, index) in activeColour.garment_colour_sizes"
                                                    v-bind:key="index">
                                                    <label>{{ size.size }}</label>
                                                    <input
                                                        v-model="activeColour.garment_colour_sizes[index].number"
                                                        type="number"
                                                        min="0"
                                                        step="1"
                                                        placeholder="0">
                                                </div>
                                            </div>

                                            <div class="grid-x grid-padding-x pad-top">    
                                                <div class="cell small-12">
                                                    <button class="button light-blue tall expanded">
                                                        Add to Basket
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="nextButtons === true" class="text-right">
                                        <app-design-basket></app-design-basket>
                                        <div class="grid-x grid-padding-x">
                                            <div class="cell small-12 medium-6">
                                                <button
                                                    v-on:click="addColour"
                                                    class="button tall green expanded">Add a colour</button>
                                            </div>
                                            <div class="cell small-12 medium-6">
                                                <button
                                                    v-on:click="addGarment"
                                                    class="button tall green expanded">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
import DesignBasket from '@/components/Header/DesignBasket';
import axios from '../../axios';

export default {
    name: 'ModalGarments',
    metaInfo() {
        return {
            title: 'Garments',
            titleTemplate: '%s-CustomisedClothing',
        };
    },
    components: {
        appDesignBasket: DesignBasket,
    },
    computed: {
        niceType() {
            const type = this.type;
            if (type === 'tshirts') return 'T-Shirts';
            if (type === 'lstshirts') return 'Long Sleeved T-Shirts';
            if (type === 'sweatshirts') return 'Sweat Shirts';
            if (type === 'poloshirts') return 'Polo Shirts';
            if (type === 'lspoloshirts') return 'Long Sleeved Polo Shirts';
            if (type === 'hoodies') return 'Hoodies';
            if (type === 'zippedhoodies') return 'Zipped Hoodies';
            if (type === 'shirts') return 'Shirts';
            if (type === 'lsshirts') return 'Long Sleeved Shirts';
            if (type === 'ladiesshirts') return 'Ladies Shirts';
            if (type === 'lsladiesshirts') return 'Long Sleeved Ladies Shirts';
            if (type === 'jackets') return 'Jackets';
            if (type === 'bodywarmers') return 'Bodywarmers & Gilets';
            if (type === 'softshelljackets') return 'Soft Shell Jackets';
            if (type === 'fleeces') return 'Fleeces';
            if (type === 'beanies') return 'Beanies';
            if (type === 'caps') return 'Caps';
            if (type === 'totebags') return 'Tote Bags';
            if (type === 'drawstringgymbags') return 'Drawstring Gymbags';
            if (type === 'backpacks') return 'Backpacks';
            if (type === 'messengerbags') return 'Messenger Bags';
            if (type === 'travelbags') return 'Travel Bags';
            if (type === 'joggingbottoms') return 'Jogging Bottoms';
            if (type === 'trousers') return 'Trousers';
            if (type === 'hvjackets') return 'Hi-Vis Jackes';
            if (type === 'hvtshirts') return 'Hi-Vis T-Shirts and Polos';
            if (type === 'hvvests') return 'Hi-Vis Vests';
            if (type === 'hvtrousers') return 'Hi-Vis Trousers';
            if (type === 'shorts') return 'Shorts';
            return 'None';
        },
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
    },
    data() {
        return {
            garments: [],
            garment: {},
            filterGarments: false,
            filters: {
                type: 'tshirt',
                colour: 0,
                size: 0,
            },
            offset: -10,
            loading: false,
            allLoaded: false,
            singleGarment: false,
            activeColour: false,
            basketItems: [],
            nextButtons: false,
            type: 'all',
            message: '',
            searchTerm: '',
            selectGenderFilter: 'all',
            selectTypeFilter: 'all',
            selectBrandFilter: 'all',
            selectOrderPrice: 'all',
        };
    },
    methods: {
        submitSearch(event) {
            event.preventDefault();
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.category = false;
            const postData = {};
            const garments = [];
            postData.term = this.searchTerm;
            axios.post('/Garments/search.json', postData)
            .then((response) => {
                if (response.data.garments.length === 0) {
                    this.allLoaded = true;
                    this.loading = false;
                    if (this.garments.length === 0) {
                        this.message = 'Sorry, nothing matched your search.';
                    }
                } else {
                    for (let i = 0; i < response.data.garments.length; i += 1) {
                        garments.push(response.data.garments[i]);
                    }
                    this.garments = this.garments.concat(garments);
                    this.category = response.data.category;
                    const routePath = this.$route.path;
                    const oldParam = this.$route.params.type;
                    const newRoute = routePath.replace(oldParam, this.category.slug);
                    history.pushState(
                        {},
                        null,
                        newRoute,
                    );
                    this.loading = false;
                    window.removeEventListener('scroll', this.handleScroll);
                    this.loading = false;
                }
            });
        },
        selectFilter(filterType) {
            if (filterType === 'gender') {
                if (this.selectGenderFilter === 'all') {
                    this.filters.sex = '';
                } else {
                    this.filters.sex = this.selectGenderFilter;
                }
            }
            if (filterType === 'type') {
                this.filters.type = this.selectTypeFilter;
                this.$router.push(`/garments/${this.selectTypeFilter}`);
            }
            if (filterType === 'brand') {
                if (this.selectBrandFilter === 'all') {
                    this.filters.brand = '';
                } else {
                    this.filters.brand = this.selectBrandFilter;
                }
            }
            if (filterType === 'orderPrice') {
                this.filters.order = this.selectOrderPrice;
            }
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.handleScroll();
        },
        addGarment() {
            this.singleGarment = false;
            this.activeColour = false;
            this.nextButtons = false;
        },
        addColour() {
            this.activeColour = false;
            this.nextButtons = false;
        },
        clearFilters() {
            this.filters.type = 'all';
            this.filters.colour = 0;
            this.filters.size = 0;
            this.filters.price = 0;
            this.value = [0, 100];
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.handleScroll();
        },
        changeType(event) {
            const element = event.currentTarget;
            const type = element.getAttribute('data-value');
            this.filters.type = type;
            this.type = type;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.handleScroll();
        },
        filterPrice() {
            const price = this.value;
            this.filters.price = price;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.handleScroll();
        },
        filterColour(event) {
            const element = event.currentTarget;
            const colour = element.getAttribute('data-value');
            this.filters.colour = colour;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.handleScroll();
        },
        filterSize(event) {
            const element = event.currentTarget;
            const size = element.getAttribute('data-value');
            this.filters.size = size;
            this.garments = [];
            this.loading = false;
            this.allLoaded = false;
            this.offset = -10;
            this.handleScroll();
        },
        addToBasket(event) {
            event.preventDefault();
            this.$store.dispatch('addGarmentToBasket', this.activeColour.garment_colour_sizes);
            this.nextButtons = true;
        },
        chooseColour(index) {
            this.activeColour = this.garment.garment_colours[index];
        },
        garmentDetails(garmentId) {
            axios.get(`/Garments/fetchSingle/${garmentId}.json`)
                .then((response) => {
                    this.garment = response.data.garment;
                    this.singleGarment = true;
                });
        },
        handleScroll() {
            if (this.loading === false && this.allLoaded === false) {
                this.loading = true;
                this.offset = this.offset + 10;
                const payload = {};
                payload.offset = this.offset;
                payload.filters = this.filters;
                const garments = [];
                const type = this.type;
                axios.post(`/Garments/fetch.json?type=${type}`, payload)
                    .then((response) => {
                        if (response.length === 0) {
                            this.allLoaded = true;
                            this.loading = false;
                        } else {
                            for (let i = 0; i < response.data.garments.length; i += 1) {
                                garments.push(response.data.garments[i]);
                            }
                            this.garments = this.garments.concat(garments);
                            this.loading = false;
                        }
                    });
            }
        },
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        this.filters.type = this.type;
    },
    mounted() {
        this.handleScroll();
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Garments/ModalGarments.vue